module.exports = __webpack_public_path__ + "static/media/wc_info_slider_2.a7640660.svg";